
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Baufaktura Academy
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              Wir begleiten Unternehmen dabei, Prozesse zu digitalisieren, Effizienz zu steigern und bessere Kundenerlebnisse zu schaffen. Mit über 35 Jahren Erfahrung und mehr als 20.000 Kunden.
            </p>
            <div className="flex space-x-4">
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-linkedin-fill text-white"></i>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-twitter-fill text-white"></i>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-facebook-fill text-white"></i>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><span className="text-gray-300 hover:text-white transition-colors cursor-pointer">Digitalisierung</span></li>
              <li><span className="text-gray-300 hover:text-white transition-colors cursor-pointer">Prozessoptimierung</span></li>
              <li><span className="text-gray-300 hover:text-white transition-colors cursor-pointer">KI-Integration</span></li>
              <li><span className="text-gray-300 hover:text-white transition-colors cursor-pointer">Fördermittel</span></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">
                <i className="ri-phone-line mr-2"></i>
                +49 (0) 123 456 789
              </li>
              <li className="text-gray-300">
                <i className="ri-mail-line mr-2"></i>
                info@business-academy.de
              </li>
              <li className="text-gray-300">
                <i className="ri-map-pin-line mr-2"></i>
                Deutschland
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Baufaktura Academy. Alle Rechte vorbehalten.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <span className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Datenschutz</span>
            <span className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Impressum</span>
            <span className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">AGB</span>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white transition-colors text-sm">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
